import { FilterableQueryParams } from 'models/FilterableQueryParams';
import {
  NextQueryParamValue,
  ShopSearchRawQueryParams
} from 'models/ShopSearchRawQueryParams';
import { isEmbedActive } from './isEmbedActive';

/** First string value from a Next.js-style query entry (for scalar use). */
export function nextQueryFirstString(
  value: NextQueryParamValue | undefined
): string | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return undefined;
  }
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}

/**
 * Coerce raw router / `context.query` into typed {@link FilterableQueryParams}.
 */
export function normalizeShopSearchRawQuery(
  raw: Partial<ShopSearchRawQueryParams> | Record<string, unknown>
): FilterableQueryParams {
  const q = nextQueryFirstString(raw.q as NextQueryParamValue);
  const sort = nextQueryFirstString(raw.sort as NextQueryParamValue);
  const account = nextQueryFirstString(raw.account as NextQueryParamValue);
  const category = nextQueryFirstString(raw.category as NextQueryParamValue);
  const keyword = nextQueryFirstString(raw.keyword as NextQueryParamValue);
  const pageStr = nextQueryFirstString(raw.page as NextQueryParamValue);
  let page: number | undefined;
  if (pageStr !== undefined && pageStr !== '') {
    const n = parseInt(pageStr, 10);
    if (!isNaN(n)) {
      page = n;
    }
  }
  const hasValidCertificate = Object.prototype.hasOwnProperty.call(
    raw,
    'hasValidCertificate'
  );
  const embedActive = isEmbedActive(raw.embed as NextQueryParamValue);

  const out: FilterableQueryParams = {};
  if (q !== undefined && q !== '') {
    out.q = q;
  }
  if (sort !== undefined && sort !== '') {
    out.sort = sort;
  }
  if (account !== undefined && account !== '') {
    out.account = account;
  }
  if (category !== undefined && category !== '') {
    out.category = category;
  }
  if (keyword !== undefined && keyword !== '') {
    out.keyword = keyword;
  }
  if (page !== undefined) {
    out.page = page;
  }
  if (hasValidCertificate) {
    out.hasValidCertificate = true;
  }
  if (embedActive) {
    out.embed = true;
  }
  return out;
}
